import React from "react";
import { getLocalStore } from "../../helper/utility";
import { getPDF, getCSV } from "../../services/grocery_list.services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { toggleExportLoader, checkCartValidity } from "../../redux/cart/action";
import { setGlobalError } from "../../redux/error/action";
import { clearLocalStorage } from "../../helper/utility";
const ExportButton = ({
  type,
  toggleExportLoader,
  exportLoading,
  setModalOpen,
  checkCartValidity,
  setGlobalError,
}) => {
  const handleClick = () => {
    const isValid = checkCartValidity();
    if (isValid) {
      setModalOpen(false);
      toggleExportLoader(true);
      const localStore = getLocalStore();
      if (type === "pdf") {
        getPDF({ id_param_url: localStore })
          .then((response) => downloadFile(response))
          .catch(async (err) => {
            const error = await err.response.data.text();
            const errorJson = await JSON.parse(error);
            const dataToReducer = { data: errorJson };

            setGlobalError(dataToReducer);
            clearLocalStorage();
          })
          .finally(() => {
            toggleExportLoader(false);
          });
      } else if (type === "csv") {
        getCSV({ id_param_url: localStore })
          .then((response) => downloadFile(response))
          .catch(async (err) => {
            const error = await err.response.data.text();
            const errorJson = await JSON.parse(error);
            const dataToReducer = { data: errorJson };

            setGlobalError(dataToReducer);
            clearLocalStorage();
          })
          .finally(() => {
            toggleExportLoader(false);
          });
      } else {
        console.log("Formato non supportato");
        toggleExportLoader(false);
      }
    }
  };

  const downloadFile = (response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Carrello.${type}`);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <button onClick={handleClick} className="btn btn-secondary">
      <FontAwesomeIcon
        icon={type === "pdf" ? faFilePdf : faFileCsv}
        size="sm"
        color={"white"}
      />{" "}
      Esporta {type}
    </button>
  );
};

const mapStateToProps = (state) => {
  return {
    exportLoading: state.cartReducer.exportLoading,
  };
};
export default connect(mapStateToProps, {
  toggleExportLoader,
  checkCartValidity,
  setGlobalError,
})(ExportButton);
